import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ModalHead } from "../common-styling";
import SpinnerButton from "../spinner-button/spinner-button";
import { useState } from "react";
import { moveHubspotCustomer } from "../../services/api-declaration";
import { showError, showSuccess } from "../../services/toast-service";

const MoveCustomerDialog = ({
  show,
  toggleDialog,
  customerId,
  fetchCustomersData
}) => {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleMove = async () => {
    setIsSubmitting(true);
    try {
      const response = await moveHubspotCustomer(customerId);
      toggleDialog();
      fetchCustomersData();
      showSuccess(response.data.message || "Customer moved successfully");
    } catch (error) {
      console.error("Error submitting form:", error);
      showError(error.response.data.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={toggleDialog} backdrop="static">
      <ModalHead className={`fw-bold "text-light"}`} $bg="warning">
        <Modal.Title>{t("moveToCustomerDialog.title")}</Modal.Title>
      </ModalHead>
      <Modal.Body>{t("moveToCustomerDialog.para")}</Modal.Body>
      <Modal.Footer className={`border-warning`}>
        <div className="d-flex flex-row-reverse">
          <Button
            className="ms-2"
            variant="outline-secondary"
            onClick={() => {
              toggleDialog();
            }}
          >
            {t("common.cancel")}
          </Button>
          {isSubmitting ? (
            <SpinnerButton
              btnText={t("moveToCustomerDialog.saving")}
              btnStyle="btn-outline-success"
            />
          ) : (
            <Button
              type="button"
              onClick={handleMove}
              variant="outline-success"
            >
              {t("moveToCustomerDialog.btn")}
            </Button>
          )}
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default MoveCustomerDialog;
